<template>
  <div>
    <h1>Plan</h1>
    <form id="search" @submit="checkForm">
      <label for="name">{{ $t("admin.adminPlanView.name") }}: </label
      ><input
        id="name"
        name="name"
        maxlength="30"
        v-model="planData.name"
        v-bind:class="{ error: errPlanName || errSurrogatePair }"
      /><br />
      <label for="description"
        >{{ $t("admin.adminPlanView.description") }}: </label
      ><textarea
        id="description"
        name="description"
        maxlength="300"
        v-model="planData.description"
        v-bind:class="{ error: errPlanSummary }"
      ></textarea
      ><br />
      <label for="enabled">{{ $t("admin.adminPlanView.enabled") }}: </label
      ><input
        id="enabled"
        name="enabled"
        v-model="planData.enabled"
        type="checkbox"
      /><br />
      <label for="planType">{{ $t("admin.adminPlanView.planType") }}: </label>
      <select
        id="planType"
        name="planType"
        v-model="planData.planType"
        v-on:change="updateForm = true"
      >
        <option
          v-for="(planType, index) in planTypes"
          v-bind:key="index"
          v-bind:value="planType.value"
        >
          {{ planType.text }}
        </option>
      </select>
      <br />
      <label for="policy">{{ $t("admin.adminPlanView.policy") }}: </label>
      <select
        id="policy"
        name="policy"
        v-model="planData.policyId"
        v-on:change="updateForm = true"
      >
        <option
          v-for="(policy, index) in selectPolicy"
          v-bind:key="index"
          v-bind:value="policy.policyId"
        >
          {{ policy.policyName }}
        </option>
      </select>
      <br />
      <label for="theme">{{ $t("admin.adminPlanView.planTheme") }}: </label>
      <select
        id="theme"
        name="theme"
        v-model="planData.theme"
        v-on:change="updateForm = true"
      >
        <option
          v-for="(theme, index) in planThemes"
          v-bind:key="index"
          v-bind:value="theme.value"
        >
          {{ theme.text }}
        </option>
      </select>

      <br />
      <label for="maxConcurrentTasks"
        >{{ $t("admin.adminPlanView.maxConcurrentTasks") }}: </label
      ><input
        id="maxConcurrentTasks"
        name="maxConcurrentTasks"
        v-model="planData.maxConcurrentTasks"
      /><br />
      <label for="maxPlanMembers"
        >{{ $t("admin.adminPlanView.maxPlanMembers") }}: </label
      ><input
        id="maxPlanMembers"
        name="maxPlanMembers"
        v-model="planData.maxPlanMembers"
      /><br />
      <div v-if="!planData.meterCurrentlyUnlimited && meter">
        <label for="meter">{{ $t("admin.adminPlanView.meterValue") }}: </label
        ><input
          id="meter"
          name="meter"
          v-model="meter.currentValue"
          type="text"
          readonly
        /><br />
      </div>
      <label for="mfa">{{ $t("admin.adminPlanView.mfa") }}: </label
      ><input
        id="mfa"
        name="mfa"
        v-model="planData.mfa"
        type="checkbox"
      /><br />

      <label for="whitelist">{{ $t("admin.adminPlanView.whitelist") }}: </label
      ><input
        id="whitelist"
        name="whitelist"
        v-model="planData.whitelist"
        type="checkbox"
      /><br />

      <input
        type="submit"
        class="submit"
        v-bind:value="$t('admin.adminPlanView.button.update')"
      />
    </form>
    <AdminPlanDelete v-bind:plan="planData" />

    <hr />
    <AdminWhitelistView :plan-id="this.planData.id" />

    <hr />
    <div v-if="planData.id">
      <h2>Groups</h2>
      <AdminGroupList
        :plan-id="this.planData.id"
        :meter-unlimited="this.planData.meterCurrentlyUnlimited"
      ></AdminGroupList>
    </div>

    <hr />
    <h2>{{ $t("admin.adminPlanView.oneTimePurchase") }}</h2>
    <table class="datatable">
      <caption class="caption">
        Plan one time purchase list table
      </caption>
      <tr>
        <th scope="col">{{ $t("admin.adminPlanView.table.timestamp") }}</th>
        <th scope="col">{{ $t("admin.adminPlanView.table.user") }}</th>
        <th scope="col">{{ $t("admin.adminPlanView.table.credits") }}</th>
        <th scope="col">{{ $t("admin.adminPlanView.table.cost") }}</th>
        <th scope="col">{{ $t("admin.adminPlanView.table.offlineCost") }}</th>
      </tr>
      <tr v-for="(otp, index) in otpList" v-bind:key="index">
        <td>{{ new Date(otp.purchaseTimestamp).toLocaleString() }}</td>
        <td>
          <router-link :to="'/admin/userView/' + otp.appUserId">{{
            otp.appUserEmailAddress
          }}</router-link>
        </td>
        <td>{{ otp.creditCount }}</td>
        <td>{{ otp.cost }}</td>
        <td>{{ otp.offlineCost }}</td>
      </tr>
    </table>

    <h3>{{ $t("admin.adminPlanView.newOneTimePurchase") }}</h3>
    <form id="oneTimePurchase" @submit="createOneTimePurchase">
      <label for="credits">{{ $t("admin.adminPlanView.credits") }}: </label
      ><input
        id="credits"
        name="credits"
        maxlength="8"
        v-model="oneTimePurchase.creditCount"
      /><br />
      <label for="offlineCost"
        >{{ $t("admin.adminPlanView.offlineCost") }}: </label
      ><input
        id="offlineCost"
        name="offlineCost"
        maxlength="8"
        v-model="oneTimePurchase.offlineCost"
      /><br />
      <input
        type="submit"
        class="submit"
        v-bind:value="$t('admin.adminPlanView.button.create')"
      />
    </form>

    <hr />
    <h2>{{ $t("admin.adminPlanView.meterModifications") }}</h2>
    <table class="datatable">
      <caption class="caption">
        Plan meter list table
      </caption>
      <tr>
        <th scope="col">{{ $t("admin.adminPlanView.table.timestamp") }}</th>
        <th scope="col">{{ $t("admin.adminPlanView.table.user") }}</th>
        <th scope="col">{{ $t("admin.adminPlanView.table.credits") }}</th>
        <th scope="col">{{ $t("admin.adminPlanView.table.reason") }}</th>
      </tr>
      <tr v-for="(mm, index) in meterModList" v-bind:key="index">
        <td>{{ new Date(mm.eventTimestamp).toLocaleString() }}</td>
        <td>
          <router-link :to="'/admin/userView/' + mm.userId">{{
            mm.userName
          }}</router-link>
        </td>
        <td>{{ mm.modification }}</td>
        <td>{{ mm.reason }}</td>
      </tr>
    </table>

    <h3>{{ $t("admin.adminPlanView.manuallyModifyMeter") }}</h3>
    <form id="meterMod" @submit="createMeterModification">
      <label for="modification">{{ $t("admin.adminPlanView.credits") }}: </label
      ><input
        id="modification"
        name="modification"
        maxlength="8"
        v-model="meterMod.modification"
      /><br />
      <label for="reason">{{ $t("admin.adminPlanView.reason") }}: </label
      ><input id="reason" name="reason" v-model="meterMod.reason" /><br />
      <input
        type="submit"
        class="submit"
        v-bind:value="$t('admin.adminPlanView.button.modify')"
      />
    </form>

    <hr />
    <h2>{{ $t("admin.adminPlanView.auditLog") }}</h2>
    <AdminAuditLogList
      :attrs="{ planId: this.$route.params.planId }"
    ></AdminAuditLogList>
  </div>
</template>

<script>
import { adminService } from "@/services/admin.service";
import AdminAuditLogList from "./AdminAuditLogList";
import AdminGroupList from "./AdminGroupList";
import AdminPlanDelete from "./AdminPlanDelete";
import AdminWhitelistView from "./AdminWhitelistView";
import { validSurrogatePair } from "@/utils/validSurrogatePair";
import { validFileInclusion } from "@/utils/validFileInclusion";

export default {
  name: "AdminPlanView",
  components: {
    AdminGroupList,
    AdminPlanDelete,
    AdminAuditLogList,
    AdminWhitelistView,
  },
  data: function () {
    return {
      planData: {},
      planTypes: [
        {
          text: this.$t("admin.adminPlanView.planTypeSelect.select.item01"),
          value: "1",
        },
        {
          text: this.$t("admin.adminPlanView.planTypeSelect.select.item02"),
          value: "2",
        },
      ],
      planThemes: [
        {
          text: this.$t("admin.adminPlanCreate.planThemeSelect.select.item00"),
          value: null,
        },
        {
          text: this.$t("admin.adminPlanCreate.planThemeSelect.select.item01"),
          value: "sakura",
        },
        {
          text: this.$t("admin.adminPlanCreate.planThemeSelect.select.item02"),
          value: "compass",
        },
        {
          text: this.$t("admin.adminPlanCreate.planThemeSelect.select.item03"),
          value: "coffee",
        },
      ],
      policyData: {},
      selectPolicy: [],
      otpList: [],
      meter: null,
      meterModList: [],
      oneTimePurchase: {
        creditCount: 0,
        offlineCost: 0.0,
      },
      meterMod: {
        credits: 0,
        reason: "",
      },
      invalidForm: true,
      errPlanName: false,
      errSurrogatePair: false,
      errPlanSummary: false,
    };
  },
  created: async function () {
    await this.fetchData();
  },
  methods: {
    fetchData: function () {
      return new Promise(async (resolve) => {
        await adminService.planGet(this.$route.params.planId).then((data) => {
          this.planData = data;
          if (data.description) {
            this.planData.description = decodeURIComponent(
              atob(data.description)
            );
          }
          this.planData.meterCurrentlyUnlimited = this.planData.unlimitedMeter;
          this.planData.maxPlanMembers = data.maxPlanMembers;
        });
        await adminService
          .planGetForOuter(this.$route.params.planId)
          .then((data) => {
            this.planData.planType = data.planType;
            this.planData.maxConcurrentTasks = data.maxConcurrentTasks;
          });
        await adminService
          .oneTimePurchaseList(this.$route.params.planId)
          .then((data) => {
            this.otpList = data;
          });
        await adminService.policySearch(null).then((data) => {
          this.selectPolicy = data;
        });
        await adminService
          .meterForPlan(this.$route.params.planId)
          .then((data) => {
            this.meter = data;
          });
        await adminService
          .meterModificationListForPlan(this.$route.params.planId)
          .then((data) => {
            this.meterModList = data;
          });
        resolve();
      }).catch((err) => {
        console.error("Unable to get plan view: ", err);
      });
    },
    checkForm: function (event) {
      this.invalidForm = false;
      this.errPlanName = false;
      this.errSurrogatePair = false;
      this.errPlanSummary = false;

      if (
        this.planData.name === "" ||
        this.planData.name.length > 30 ||
        validFileInclusion(this.planData.name)
      ) {
        this.invalidForm = true;
        this.errPlanName = true;
      }

      if (validSurrogatePair(this.planData.name)) {
        this.invalidForm = true;
        this.errSurrogatePair = true;
      }

      if (
        this.planData.description === "" ||
        this.planData.description.length > 300
      ) {
        this.invalidForm = true;
        this.errPlanSummary = true;
      }

      if (!this.invalidForm) {
        this.updatePlan();
      }

      event.preventDefault();
    },
    updatePlan: function (e) {
      let tmpPlanData = JSON.parse(JSON.stringify(this.planData));
      tmpPlanData.description = btoa(
        encodeURIComponent(this.planData.description)
      );

      adminService
        .planUpdate(this.$route.params.planId, tmpPlanData)
        .then(async () => {
          await this.fetchData();
        })
        .catch((err) => {
          console.error("Unable to update plan: ", err);
        });
    },
    createOneTimePurchase: function (e) {
      e.preventDefault();
      adminService
        .oneTimePurchaseCreate(this.$route.params.planId, this.oneTimePurchase)
        .then(async () => {
          await this.fetchData();
        })
        .catch((err) => {
          console.error("Unable to create one time purchase: ", err);
        });
    },
    createMeterModification: function (e) {
      e.preventDefault();
      adminService
        .meterModificationCreate(this.$route.params.planId, this.meterMod)
        .then(async () => {
          await this.fetchData();
        })
        .catch((err) => {
          console.error("Unable to create meter modification: ", err);
        });
    },
  },
};
</script>
